import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'; // or 'libphonenumber-js/mobile' if preferred
//import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
const API_URL = process.env.REACT_APP_API_URL;
countries.registerLocale(enLocale);

export default function TeacherDetail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

const getCountryName = (code) => {
  return countries.getName(code, 'en'); // 'ET' => 'Ethiopia'
};
  

  const [form, setForm] = useState({
  userId: "",
  gender: "",
  date_of_birth: "",
  phone_number: '',
  country_code: '',
  country: '',
  educational_qualification: "",
  institution_name: "",
  department: "",           // <-- Added department
  description: "",          // <-- Added description
  subjects_taught: "",
  teaching_levels: "",
  experience_years: "",
  language_proficiency: "",
  hourly_rate: "",
  currency: "ETB",
  profilePhoto: null,
  certificate: null,

});


 const [loading, setLoading] = useState(false);



useEffect(() => {
  const userId = searchParams.get("userId");
  if (userId) {
    setForm((prev) => ({ ...prev, userId }));
  }
}, [searchParams]); // ✅ Include dependency


  const departmentOptions = [
  { value: "Computer Science", label: "Computer Science" },
  { value: "Information Technology", label: "Information Technology" },
  { value: "Software Engineering", label: "Software Engineering" },
  { value: "Artificial Intelligence", label: "Artificial Intelligence" },
  { value: "Mathematics", label: "Mathematics" },
  { value: "Statistics", label: "Statistics" },
  { value: "Physics", label: "Physics" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Biology", label: "Biology" },
  { value: "Geology", label: "Geology" }

];





  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);

  const validateField = (name, value) => {
    let message = "";
    if (name === "phone_number" && !/^\+?\d{9,15}$/.test(value)) {
      message = "Enter a valid phone number";
    }
    setErrors((prev) => ({ ...prev, [name]: message }));
  };

const handleChange = (e) => {
  const { name, value, files } = e.target;
  if (files && files.length > 0) {
    setForm(prev => ({ ...prev, [name]: files[0] }));
  } else {
    setForm(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  }
};

const handlePhoneChange = (value) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(value || '');

    if (phoneNumber) {
      const countryCode = phoneNumber.country || '';
      const countryName = countries.getName(countryCode, 'en', { select: 'official' }) || '';

      setForm((prev) => ({
        ...prev,
        phone_number: value,
        country_code: countryCode, // e.g., 'ET'
        country: countryName,      // e.g., 'Ethiopia'
      }));
    } else {
      throw new Error('Invalid phone number');
    }
  } catch (error) {
    console.error('Phone parsing error:', error);

    setForm((prev) => ({
      ...prev,
      phone_number: value,
      country_code: '',
      country: '',
    }));
  }
};

const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const maxSize = 5 * 1024 * 1024; // 5MB

  const validFiles = files.filter(file => file.size <= maxSize);

  if (validFiles.length !== files.length) {
    alert("Some files were too large (max 5MB each) and were skipped.");
  }

  setForm({
    ...form,
    certificate: validFiles,
  });
};












 const handleSubmit = async (e) => {
  e.preventDefault();

 setLoading(true); 
  const formData = new FormData();

  Object.entries(form).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value);
    } else {
      formData.append(key, value);
    }
  });

  try {
    const res = await axios.post(`${API_URL}/api/teacher/register-teacher`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    alert("Registration successful!");
       navigate("/teacher/dashboard");
    console.log(res.data);
  } catch (err) {
    alert("Error: " + (err.response?.data?.message || "Submission failed."));
  }
  finally {
    setLoading(false); 
  }



};


  return (
    <div className="max-w-2xl mx-auto p-8 bg-white rounded-xl shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Teacher Registration</h2>

      {/* Toggle Preview */}
      <button
        type="button"
        onClick={() => setShowPreview(!showPreview)}
        className="mb-6 bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
      >
        {showPreview ? "Hide Preview" : "Show Preview"}
      </button>

      {/* Preview Panel */}
      {showPreview && (
        <div className="bg-gray-100 p-4 rounded-lg shadow mb-6">
          <h3 className="text-lg font-bold mb-2">Preview</h3>
          <p><strong>Gender:</strong> {form.gender}</p>
          <p><strong>DOB:</strong> {form.date_of_birth}</p>
          <p><strong>Phone:</strong> {form.phone_number}</p>
          <p><strong>Country:</strong> {form.country}</p>
          <p><strong>Region:</strong> {form.region}</p>
          <p><strong>Institution:</strong> {form.institution_name}</p>
          <p><strong>Subjects:</strong> {form.subjects_taught}</p>
          <p><strong>Languages:</strong> {form.language_proficiency}</p>
          <p><strong>Rate:</strong> {form.hourly_rate} {form.currency}</p>
          {form.profilePhoto && <img src={URL.createObjectURL(form.profilePhoto)} alt="Profile" className="w-32 h-32 mt-4 rounded-full" />}
    

          {form.certificate && <p className="mt-2 text-sm">📎 Certificate ready: {form.certificate.name}</p>}
        </div>
      )}

{loading && (
  <div className="flex justify-center items-center mb-4">
    <svg className="animate-spin h-6 w-6 text-blue-600 mr-2" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8z"
      />
    </svg>
    <p>Submitting your registration...</p>
  </div>
)}

      <form onSubmit={handleSubmit}>
        {/* Gender */}



        <label className="block mb-1 font-medium text-gray-700">Description / Bio</label>
<textarea
  name="description"
  value={form.description || ""}
  onChange={handleChange}
  placeholder="Introduce yourself to your students.."
  rows={4}
  className="w-full border p-3 rounded-md resize-y focus:outline-none focus:ring-2 focus:ring-blue-500"
/>
        <label className="block mb-2 font-medium">Gender</label>
        <select name="gender" value={form.gender} onChange={handleChange} required
          className="form-select mb-4 w-full p-3 border rounded-md">
          <option value="">Select Gender</option>
          <option>Male</option>
          <option>Female</option>
        </select>

        {/* Date of Birth */}
        <label className="block mb-2 font-medium">Date of Birth</label>
        <input type="date" name="date_of_birth" value={form.date_of_birth} onChange={handleChange} required
          placeholder="MM/DD/YYYY"
          className="w-full border p-3 rounded-md mb-4" />

        {/* Phone */}
      
        
     <label className="block mb-2 font-medium">Phone Number</label>
<PhoneInput
  country={'et'} // Default country: Ethiopia
  value={form.phone_number}
  onChange={handlePhoneChange}
  inputClass="w-full border p-3 rounded-md mb-4"
  containerClass="mb-4"
  enableAreaCodes={true}
  countryCodeEditable={false}
  disableCountryCode={false}
  placeholder="Enter phone number"
/>
    

        {/* Education */}
       <label className="block mb-2 font-medium">Qualification</label>
<select
  name="educational_qualification"
  value={form.educational_qualification}
  onChange={handleChange}
  required
  className="w-full border p-3 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
>
 <option value="">Select your highest qualification</option>
<option value="Certificate">Certificate</option>
<option value="Diploma">Diploma</option>

<option value="BSc">Bachelor of Science (BSc)</option>
<option value="BA">Bachelor of Arts (BA)</option>


<option value="MSc">Master of Science (MSc)</option>
<option value="MA">Master of Arts (MA)</option>
<option value="DR">Doctor</option>
</select>
<label className="block mb-2 font-medium">Department</label>
<Select
  options={departmentOptions}
  onChange={(selected) => setForm(prev => ({ ...prev, department: selected ? selected.value : "" }))}
  placeholder="Search or select a department"
  className="mb-4"
  classNamePrefix="react-select"
/>


        <label className="block mb-2 font-medium">Institution Name</label>
        <input type="text" name="institution_name" value={form.institution_name} onChange={handleChange}
          placeholder="e.g. Addis Ababa University"
          required className="w-full border p-3 rounded-md mb-4" />

        {/* Subjects & Levels */}
        <label className="block mb-2 font-medium">Subjects you   Teach</label>

        <input type="text" name="subjects_taught" value={form.subjects_taught} onChange={handleChange}
          placeholder="e.g. Math, Chemistry"
          required className="w-full border p-3 rounded-md mb-4" />

     

        <label className="block mb-2 font-medium">Teaching Levels(grades) you teach</label>
        <input type="text" name="teaching_levels" value={form.teaching_levels} onChange={handleChange}
          placeholder="e.g. grade 10 High School, College"
          required className="w-full border p-3 rounded-md mb-4" />

        {/* Experience */}
        <label className="block mb-2 font-medium">Years of Experience</label>
        <input type="number" name="experience_years" value={form.experience_years} onChange={handleChange}
          placeholder="e.g. 5"
          required className="w-full border p-3 rounded-md mb-4" />

        {/* Languages */}
        <label className="block mb-2 font-medium">Language Proficiency</label>
        <input type="text" name="language_proficiency" value={form.language_proficiency} onChange={handleChange}
          placeholder="e.g. English, Amharic"
          required className="w-full border p-3 rounded-md mb-4" />

        {/* Hourly Rate & Currency */}
        <label className="block mb-2 font-medium">Hourly Rate</label>
        <div className="flex gap-4 mb-6">
          <input type="number" name="hourly_rate" value={form.hourly_rate} onChange={handleChange}
            placeholder="e.g. 20"
            required className="flex-1 border p-3 rounded-md" />
          <select
  name="currency"
  value={form.currency}
  onChange={handleChange}
  required
  className="w-40 border p-3 rounded-md"
>
  <option value="">Currency</option>
  <option value="ETB">ETB (Birr)</option>
  <option value="USD">USD (Dollar)</option>
  <option value="GBP">GBP (Pound)</option>
  <option value="EUR">EUR (Euro)</option>
</select>
        </div>

        {/* File Uploads */} <label className="block mb-2 font-medium">Profile Photo</label> 
        <input type="file" name="profilePhoto" onChange={handleChange} accept="image/*" 
          className="w-full border p-3 rounded-md mb-4" /> 
          <label className="block mb-2 font-medium">Teaching Certificate</label> 
  

<input
  type="file"
  name="certificate"
  onChange={handleChange}
  accept=".pdf,.doc,.docx"

  className="w-full border p-3 rounded-md mb-6"
/>


         

<button
  type="submit"
  disabled={loading}
  className={`w-full bg-gradient-to-r from-blue-600 to-purple-700 text-white font-bold py-3 rounded-lg shadow-lg transition ${
    loading ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"
  }`}
>
  {loading ? "Submitting..." : "Submit Registration"}
</button>
</form> </div> );

}
